import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Http, ResponseContentType } from '@angular/http';
import { Subscription } from 'rxjs/Subscription';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Location } from '@angular/common';
import * as FileSaver from 'file-saver';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import 'rxjs/add/operator/toPromise';
import { NotificationsService } from 'angular2-notifications';
import { environment } from '../../../../environments/environment';
import { AdvtService } from '../../../_services/advt.service';
import { AlertService } from '../../../_services';

@Component({
  selector: 'app-free-detail',
  templateUrl: './free-detail.component.html',
  styleUrls: ['./free-detail.component.css']
})
export class FreeDetailComponent implements OnInit {
  @ViewChild("myVideo") public myVideo: any;
  @ViewChild("myAudio") public myAudio: any;
  @ViewChild("template") public template: TemplateRef<any>;
  @ViewChild("ratingtemplate") public ratingtemplate: TemplateRef<any>;
  @ViewChild("sellerModal") public sellerModal: TemplateRef<any>;


  modalRef: BsModalRef;
  private sub: Subscription;
  public _id;
  item_id;
  amount;
  buyer_id;
  seller_id;
  public listSingleItem;
  public itemVideoName;
  public itemAudioName;
  public itemImageName;
  public bidPost: Boolean = false;
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  galleryMusic = [];
  placeholder: any;
  currentUser: any;
  showButton: Boolean = false;
  showdownloadbutton: Boolean = false;
  NAP;
  myTracks: any[];
  allTracks: any[];
  selectedTrack;
  ItemData;
  bidButton: Boolean = false;
  bidAmount;
  timeset;
  duration;
  control;
  MaxAmount;
  maxAmt;
  bid_Amount;
  mainLoader;
  loading: Boolean = false;
  modalText: String = '';
  UsersRating: Array<any> = [];
  UserRatingCount;
  pageSize = 5;
  pageNo = 1;
  ItemAvailable;
  imageData: any;
  modal_message;
  is_seller_status: Boolean = false;
  dismesUp: Boolean = false;
  userId: string;

  constructor(private advtService: AdvtService,
    private alertService: AlertService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private _location: Location,
    private http: Http,
    private sanitizer: DomSanitizer,
    private _NotificationsService: NotificationsService,
    private router: Router
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.NAP = '../../assets/images/nap.jpg';
    this.mainLoader = '../../assets/images/BigLoader.gif';
    const userInfo = JSON.parse(localStorage.getItem('currentUser'));
    this.userId = userInfo.result.id;
    this.currentUser = userInfo ? userInfo.result : null;
    this.buyer_id = userInfo.result ? userInfo.result.id : null;


    this.sub = this.route.params.subscribe((params) => {
      this._id = params['id'];
    });
    this.placeholder = '../../assets/images/pdf.png';


    this.getItemDetail();

    this.galleryOptions = [
      {
        width: '100%',
        height: '400px',
        thumbnailsColumns: 4,
        imageAnimation: NgxGalleryAnimation.Slide,

      },
      // max-width 800
      {
        breakpoint: 800,
        width: '100%',
        height: '600px',
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20,
      },
      // max-width 400
      {
        breakpoint: 400,
        preview: false,
      }
    ];

    // this.myTracks = [{
    //   src: 'https://archive.org/download/JM2013-10-05.flac16/V0/jm2013-10-05-t12-MP3-V0.mp3',
    //   artist: 'John Mayer',
    //   title: 'Why Georgia',
    //   art: 'img/johnmayer.jpg',
    //   preload: 'metadata' // tell the plugin to preload metadata such as duration for this track, set to 'none' to turn off
    // },
    // {
    //   src: 'https://archive.org/download/JM2013-10-05.flac16/V0/jm2013-10-05-t30-MP3-V0.mp3',
    //   artist: 'John Mayer',
    //   title: 'Who Says',
    //   art: 'img/johnmayer.jpg',
    //   preload: 'metadata' // tell the plugin to preload metadata such as duration for this track,  set to 'none' to turn off
    // }];
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
      alert('Opera');
    }
    else if (navigator.userAgent.indexOf("Chrome") != -1) {
      this.showdownloadbutton = false;
      //  alert('Chrome');
    }
    else if (navigator.userAgent.indexOf("Safari") != -1) {
      this.showdownloadbutton = true;
    }
    else if (navigator.userAgent.indexOf("Firefox") != -1) {
      this.showdownloadbutton = true;
      //alert('Firefox');
      //FileSaver.saveAs(audiourl, itemAudioName);
    }
    /*else if((navigator.userAgent.indexOf("MSIE") != -1 ) || (!!document.documentMode == true )) //IF IE > 10
    {
        alert('IE');
    } */
    else {
    }





  }

  /**
   *
   */
  public getItemDetail() {
    this.item_id = this._id;
    this.galleryImages = [];
    this.galleryMusic = [];

    this.advtService.getItemDetail(this.item_id)
      .subscribe(data => {
        this.ItemData = data;
        this.showButton = data.showButton;
        if (data.category_id == 2) {
          if (data.status_id == 3) {
            if (typeof data.meta.images !== 'undefined') {
              if (data.imgName) {
                this.galleryImages = [];
                for (let i = 0; i < Object.keys(data.meta.images).length; i++) {
                  if (typeof data.meta.images[i] !== 'undefined') {
                    const csvArray = data.meta.images[i];
                    this.galleryImages.push({
                      small: csvArray,
                      medium: csvArray,
                      big: csvArray
                    });
                  }
                }
              }
            }
          } else {
            if (typeof data.meta.preview_images !== 'undefined') {
              if (data.imgName) {
                this.galleryImages = [];
                for (let i = 0; i < Object.keys(data.meta.preview_images).length; i++) {
                  if (typeof data.meta.preview_images[i] !== 'undefined') {
                    const csvArray = data.meta.preview_images[i];
                    this.galleryImages.push({
                      small: csvArray,
                      medium: csvArray,
                      big: csvArray
                    });

                  }
                }
              }
            }
          }

        } else {
          if (data.imgName) {
            this.galleryImages = [];
            for (let i = 0; i < Object.keys(data.meta.images).length; i++) {
              if (typeof data.meta.images[i] !== 'undefined') {
                const csvArray = data.meta.images[i];
                this.galleryImages.push({
                  small: csvArray,
                  medium: csvArray,
                  big: csvArray
                });
              }
            }
          }
        }

        if (data.meta && data.meta.music) {
          this.galleryMusic = [];
          for (let i = 0; i < Object.keys(data.meta.music).length; i++) {
            if (typeof data.meta.music[i] !== 'undefined') {
              const csvArray = data.meta.music[i];
              this.galleryMusic.push({ 'music_url': csvArray, 'music_name': data.meta.music_name[i] });
            }
          }
        }
        this.listSingleItem = data;
        if (this.buyer_id == this.listSingleItem.buyer_id && this.listSingleItem.status_id == 3) {
          if (this.listSingleItem.meta.videos) {
            this.itemVideoName = this.listSingleItem.meta.videos.split("/")[5];
          }
          if (this.listSingleItem.meta.music !== undefined) {
            this.itemAudioName = this.listSingleItem.meta.music[0].split("/")[5];
          }
        }

        this.bid_Amount = data.min_bid;
      }, error => {
        this.alertService.error(error);
      });
  }


  public saveFile(videourl, itemVideoName) {
    var ext = videourl.substr(videourl.lastIndexOf('.') + 1);
    FileSaver.saveAs(videourl, itemVideoName);
  }

  public saveAudio(audiourl, itemAudioName) {
    FileSaver.saveAs(audiourl, itemAudioName);
  }

  public saveImageFile(imageurl, itemImageName) {
    const newImageUrl = imageurl.replace(/^https:\/\//i, 'http://');
    this.http.get(newImageUrl, {
      responseType: ResponseContentType.Blob
    })
      .toPromise()
      .then((res: any) => {
        let blob = new Blob([res._body], {
          type: res.headers.get("Content-Type")
        });
        saveAs(blob, newImageUrl.split("/")[5]);
      });

    // let url =imageurl+'?56556';
    let url = imageurl;
    if (imageurl) {
      this.itemImageName = imageurl.split("/")[5];
    }
    //let url = url.replace(/^https:\/\//i, 'http://');
    // FileSaver.saveAs(url,imageurl.split("/")[5]);
  }



  public saveAllImageFiles(imageurls) {
    let array = imageurls;
    for (let i = 0; i < array.length; i++) {
      const newImageUrl = array[i].replace(/^https:\/\//i, 'http://');
      this.http.get(newImageUrl, {
        responseType: ResponseContentType.Blob
      }).toPromise().then((res: any) => {
        let blob = new Blob([res._body], {
          type: res.headers.get("Content-Type")
        });
        saveAs(blob, newImageUrl.split("/")[5]);
      });
    };
  }


  /**
   * Function to post Bid
   */
  public postBid() {
    this.MaxAmount = 970873.77;
    if (this.ItemData.bid_type_name == 'Minimum') {
      if (parseInt(this.ItemData.min_bid) > parseFloat(this.amount)) {
        // this.bidButton = true;
        this._NotificationsService.error("Bid Amount is too Low.")
        return false;
      }
    } if (this.ItemData.bid_type_name != 'Fixed') {
      if (!this.amount) {
        this.bidButton = false;
        this._NotificationsService.error("Please Enter Bid Amount")
        return false;
      }
    }
    if (Number(this.MaxAmount) <= this.amount) {
      this.maxAmt = true;
      this._NotificationsService.error("Bid Amount should not be more than $970873.77")
      return false;
    }
    this.loading = true;
    let amount = this.amount ? this.amount : this.ItemData.min_bid;
    let buyer_id = this.buyer_id
    let item_id = this._id;
    this.advtService.postBid(amount, buyer_id, item_id).subscribe(data => {
      if (data.status === 200) {
        this.bid_Amount = data.amount;
        this.bidAmount = data;
        this.ItemData.status_id = 5;
        this.bidPost = true;
        this.alertService.success("Bid Posted Successfully!");
        this.loading = false;
        this.ngOnInit();
      } if (data.status === 400) {
        this._NotificationsService.error(data.message)
        this.loading = false;
      } else {
        this.bidPost = false;
      }
    }, error => {
      this.alertService.error(error);
    });
  }


  /**
   * function to enable or disable Bid button  on basis of bid type
   * @param searchValue : Data coming in input field
   */
  public minBid(searchValue: any) {
    this.MaxAmount = 970873.77;
    if (this.ItemData.bid_type_name === 'Minimum') {
      if (parseInt(this.ItemData.min_bid) <= searchValue) {
        this.bidButton = true;
        this._NotificationsService.error("Bid Amount is too Low.")
      } else {
        this.bidButton = false;
      }
    }
    if (this.ItemData.bid_type_id === 1) {
      this.bidButton = true;
    }
    if (!searchValue) {
      this.bidButton = false;
    }
    if (Number(this.MaxAmount) <= searchValue) {
      this.maxAmt = true;
    } else {
      this.maxAmt = false;
    }
  }


  _checkNumPattern(event: any) {
    const pattern = /[0-9\+\.\ ]/;

    if (event.which === 32 && event.target.selectionStart === 0) {
      return false;
    }
    if (event.which === 48 && event.target.selectionStart === 0) {
      return false;
    }
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }

  }




  /**
   * Function to open modal
   * @param template
   */
  public openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-md' })
    );
  }

  /**
   * function to Disbale Modal
   * @param event
   */
  _hidemodal() {
    this.modalRef.hide();
  }

  backClicked() {
    this._location.back();
  }

  AcceptEscrow() {

    let status = {
      'item_id': this._id,
      'status': 1
    };

    this.advtService.acceptpay(status).subscribe(data => {
      if (data.status === 200) {
        this.showButton = false;
        this.alertService.success("Payment accepted Successfully!");
      } else {
        this.bidPost = false;
      }
    }, error => {
      this.alertService.error(error);
    });
  }

  RejectEscrow() {

    let status = {
      'item_id': this._id,
      'status': 0
    };

    this.advtService.acceptpay(status).subscribe(data => {
      if (data.status === 200) {
        this.showButton = false;
        this.alertService.success("Payment rejected and refunded Successfully!");
      } else {
        this.bidPost = false;
        this.alertService.alert(" Stripe account doesn't existed/created ");

      }
    }, error => {
      this.alertService.error(error);
    });
  }

  /**
   * This function is used for pagination
   * @param data
   */
  /* pagingAgent_sold(data) {
      // this.loading = true;
      this.ItemAvailable = [];
      this.pageNo = (data * this.pageSize) - this.pageSize;
      const params = {
          seller_id: this.listSingleItem.seller_id,
          limit: this.pageSize,
          offset: this.pageNo,
      };
      this.advtService.getRatingList(params).subscribe(data => {
          if (data.status === 200) {
              window.scrollTo(0, 0);
              this.UsersRating = data.result;
              this.UserRatingCount = data.result.count;
          }
      });
  }*/

  getAllRatingList(ratingtemplate: TemplateRef<any>) {
    this.modalText = 'Rating';
    // this.pageNo = (this.pageSize) - this.pageSize;
    const params = {
      seller_id: this.listSingleItem.seller_id,
      limit: 10000,
      offset: 0,
    };
    this.advtService.getRatingList(params).subscribe(data => {
      if (data.status === 200) {
        this.UsersRating = data.result;
        this.UserRatingCount = data.result.count;
      }
    });
    this.modalRef = this.modalService.show(
      ratingtemplate,
      Object.assign({}, { class: 'gray modal-md' })
    );
  }

  public checkSeller(id) {
    if (this.currentUser.is_seller === 0) {
      this.is_seller_status = true;
      if (!this.dismesUp) {
        this.modal_message = 'You are not Registered as seller? If you want to post ad, Upgrade to seller';
      }
      this.openModal(this.sellerModal);
    } else {
      this.router.navigate(['./trade/trade-add', 1, this.listSingleItem.id]);
    }
  }

  public makeSeller(event) {
    this.loading = true;
    this.advtService.makeSeller(this.buyer_id).subscribe((res) => {
      if (res.status === 200) {
        if (res['redirect_to_stripe'] == 1) {
          window.location.href = environment.stripeurl + res['result']['id'];
        } else {
          this.router.navigate(['./trade/trade-add', 1, this.listSingleItem.id]);
        }
        this.loading = false;
        if (res['show_message']) {
          this.dismesUp = true;
          this.modal_message = res['message'];
          this.showButton = true;
        } else {
          /*this.router.navigate(['./trade/trade-add', 1 ,this.listSingleItem.id]);
          this._hidemodal();
          let resUpdated = JSON.parse(localStorage.getItem('currentUser'));
          resUpdated.result.is_seller = 1;
          localStorage.removeItem("currentUser");
          localStorage.setItem("currentUser", JSON.stringify(resUpdated));*/
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/authorized-data/free/free-detail/free-detail.component.ts